import React from 'react';

import ReactDocumentTitle from 'react-document-title';

type HubsDocumentTitleProps = {
	children?:
		| string
		| number
		| React.ReactElement<any, string | React.JSXElementConstructor<any>>
		| null
		| undefined;
	shouldRenderDocumentTitle: boolean;
	title?: string;
};

export const HubsDocumentTitle = ({
	title,
	shouldRenderDocumentTitle,
	children,
}: HubsDocumentTitleProps): React.JSX.Element => {
	if (!title || !shouldRenderDocumentTitle) {
		return <>{children}</>;
	}

	return <ReactDocumentTitle title={title}>{children}</ReactDocumentTitle>;
};
